import React, { useEffect, useMemo, useState } from "react";
import { Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import useBuscaSelecaoMultipla from "../../hooks/useBuscaSelecaoMultipla";

const TicketsUserSelect = ({ selectedUserIds, onChange, users: usersProp }) => {
	const safeSelected = Array.isArray(selectedUserIds) ? selectedUserIds : [];
	const [usersState, setUsersState] = useState([]);
	const users = usersProp || usersState;

	useEffect(() => {
		if (usersProp) return;
		let active = true;
		const fetch = async () => {
			try {
				const { data } = await api.get("/users-atendentes");
				if (active) {
					setUsersState(Array.isArray(data) ? data : []);
				}
			} catch (err) {
				toastError(err);
			}
		};
		fetch();
		return () => {
			active = false;
		};
	}, [usersProp]);

	const selected = useMemo(
		() => users.filter((u) => safeSelected.includes(u.id)),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[users, selectedUserIds]
	);

	const handleChange = (event, newValue) => {
		if (newValue.some((option) => option.id === "toggle-all")) {
			if (safeSelected.length === users.length) {
				onChange([]);
			} else {
				onChange(users.map((u) => u.id));
			}
			return;
		}
		onChange(newValue.map((u) => u.id));
	};

	// Mantém o texto da busca ao marcar itens (o MUI limpa por padrão).
	const busca = useBuscaSelecaoMultipla();

	return (
		<Autocomplete
			multiple
			options={[{ id: "toggle-all", name: "Selecionar Tudo" }, ...users]}
			getOptionLabel={(option) => option.name || ""}
			value={selected}
			disableCloseOnSelect
			{...busca}
			onChange={handleChange}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			ListboxProps={{
				style: {
					maxHeight: 300,
					overflowY: "auto",
					fontSize: "0.85rem",
				},
			}}
			sx={{
				fontSize: "0.85rem",
				"& .MuiAutocomplete-inputRoot": {
					padding: "4px !important",
					fontSize: "0.85rem",
				},
			}}
			renderTags={() => null}
			renderOption={(props, option, { selected: isSelected }) => (
				<MenuItem
					{...props}
					dense
					sx={{
						fontSize: "0.85rem",
						minHeight: "32px",
						paddingY: 0.5,
					}}
				>
					<Checkbox
						color="primary"
						checked={
							option.id === "toggle-all"
								? safeSelected.length === users.length && users.length > 0
								: isSelected
						}
						indeterminate={
							option.id === "toggle-all" &&
							safeSelected.length > 0 &&
							safeSelected.length < users.length
						}
						sx={{
							padding: "4px",
							"& svg": { fontSize: "18px" },
						}}
					/>
					<ListItemText
						primary={option.name}
						primaryTypographyProps={{ fontSize: "0.85rem" }}
					/>
				</MenuItem>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Filtrar por atendente"
					variant="outlined"
					margin="dense"
					InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
					placeholder={safeSelected.length === 0 || safeSelected.length >= users.length
						? `Todos (${users.length})`
						: `${safeSelected.length} de ${users.length}`}
					sx={{
						"& input": { fontSize: "0.85rem" },
						"& label": { fontSize: "0.85rem" },
					}}
				/>
			)}
		/>
	);
};

export default TicketsUserSelect;
